import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { BASE } from "./e360Primitives";

export default function InternalPricing({ clientId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open || data) return;
    api.get(`/admin/enterprise360/clients/${clientId}/pricing`)
      .then(({ data }) => setData(data)).catch(() => {});
  }, [open, data, clientId]);

  return (
    <details data-testid="e360-internal-pricing" className="border border-amber-300 bg-amber-50/40 rounded-lg p-4 mb-5"
      onToggle={(e) => setOpen(e.target.open)}>
      <summary className="cursor-pointer text-[12px] tracking-[0.14em] uppercase text-amber-700 font-semibold">
        Engagement pricing — internal only (not a client deliverable)
      </summary>
      {!data ? <p className="text-sm text-zinc-500 mt-3">Loading…</p> : (
        <div className="mt-4 space-y-3 text-sm">
          <div className="flex flex-wrap gap-6">
            <div>
              <div className="text-[11px] uppercase tracking-wider text-zinc-500">Indicative engagement value</div>
              <div data-testid="e360-pricing-value" className="text-2xl font-semibold text-black">{data.indicative_engagement_value_label}</div>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-zinc-500">Est. consulting days saved</div>
              <div className="text-2xl font-semibold text-black">{data.estimated_consulting_days}</div>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-zinc-500">Client value at stake</div>
              <div className="text-2xl font-semibold text-[var(--e360-primary)]">{data.value_at_stake_label || "—"}</div>
            </div>
          </div>
          <p className="text-xs text-zinc-500">{data.basis}</p>
          <p className="text-[11px] text-amber-700">Rate card: {data.rate_card?.name}. Indicative — for internal sales discussion and sign-off only.</p>
          <a data-testid="e360-deal-onepager" href={`${BASE}/api/admin/enterprise360/clients/${clientId}/deal-onepager`}
            target="_blank" rel="noreferrer"
            className="inline-block bg-amber-700 text-white px-4 py-2 text-[12px] tracking-[0.14em] uppercase rounded">
            Download internal deal one-pager (PDF)
          </a>
        </div>
      )}
    </details>
  );
}
